var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #cfd1d3;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.19,15.96c-.37,0-.73,.07-1.07,.17,0-.06,0-.11,0-.17,0-4.36-3.54-7.9-7.9-7.9-3.68,0-6.77,2.53-7.65,5.94-.29-.05-.59-.09-.9-.09-2.75,0-4.98,2.23-4.98,4.98,0,2.47,1.82,4.66,4.18,5.05h.04s9.34,0,9.34,0c0,0,0,0,0,0s0,0,0,0h8.48c.2,0,.34,0,.45,0,2.19,0,3.94-1.82,3.94-4.01s-1.78-3.97-3.97-3.97Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.18,
    y: 14.01,
    width: 2.02,
    height: 7.42,
    rx: 1.01,
    ry: 1.01,
    transform: "translate(-7.79 16.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.18,
    y: 14.01,
    width: 2.02,
    height: 7.42,
    rx: 1.01,
    ry: 1.01,
    transform: "translate(17.27 -6.25) rotate(45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.a0d80ee3947608a8efa2290e7ac5f1e1.svg";
export { ForwardRef as ReactComponent };